module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_10-9acaa8921dbc1e69d09441791c95375d.jpg";